import { IRenderFormField } from "src/@types/form";
import {
  IND_ENT_HIRED_WORKERS_FIELD,
  IND_ENT_WORKERS_COUNT_FIELD,
  IND_ENT_SINGLE_TAX_GROUP_FIELD,
  IND_ENT_TAXATION_SYSTEM_FIELD,
  LEG_ENT_TAXATION_SYSTEM_FIELD,
  LEG_ENT_SINGLE_TAX_GROUP_FIELD,
  LEG_ENT_VAT_PAYER_FIELD,
  LEG_ENT_EXCISE_TAX_PAYER_FIELD,
  LEGAL_FORM_FIELD,
} from "./calculator-fields";
import { DefaultStep } from "../steps/DefaultStep";
import { CalculatorField, IRenderCalculatorStep, LegalForm } from "../types";

const getFieldName = (field: IRenderFormField) => field.name as CalculatorField;

// steps for individual-entrepreneur (ФОП) - (from)
export const IND_ENT_CALCULATOR_STEPS: IRenderCalculatorStep[] = [
  {
    id: "1",
    title: "Оберіть організаційно-правову форму",
    titleClassName: "text-xl text-white-base lg:text-48",
    className: "bg-green-gradient",
    step: DefaultStep,
    responsibleFields: [getFieldName(LEGAL_FORM_FIELD)],
    fields: [LEGAL_FORM_FIELD],
  },
  {
    id: "2",
    title: "На якій ви системі оподаткування?",
    titleClassName: "text-lg lg:text-4xl",
    step: DefaultStep,
    responsibleFields: [getFieldName(IND_ENT_TAXATION_SYSTEM_FIELD)],
    fields: [IND_ENT_TAXATION_SYSTEM_FIELD],
  },
  {
    id: "3",
    title: "Яка у вас група єдиного податку?",
    titleClassName: "text-lg lg:text-4xl",
    step: DefaultStep,
    responsibleFields: [getFieldName(IND_ENT_SINGLE_TAX_GROUP_FIELD)],
    fields: [IND_ENT_SINGLE_TAX_GROUP_FIELD],
  },
  {
    id: "4",
    title: "Чи є у вас наймані працівники?",
    titleClassName: "text-lg lg:text-4xl",
    step: DefaultStep,
    responsibleFields: [getFieldName(IND_ENT_HIRED_WORKERS_FIELD)],
    fields: [IND_ENT_HIRED_WORKERS_FIELD],
  },
  {
    id: "5",
    title: "Кількість найманих працівників:",
    titleClassName: "text-lg lg:text-4xl",
    step: DefaultStep,
    responsibleFields: [getFieldName(IND_ENT_WORKERS_COUNT_FIELD)],
    fields: [IND_ENT_WORKERS_COUNT_FIELD],
  },
];
// (to)

// fields for legal entity (юо) - (from)
export const LEG_ENT_CALCULATOR_STEPS: IRenderCalculatorStep[] = [
  {
    id: "1",
    title: "Оберіть організаційно-правову форму",
    titleClassName: "text-xl text-white-base lg:text-48",
    className: "bg-green-gradient",
    step: DefaultStep,
    responsibleFields: [getFieldName(LEGAL_FORM_FIELD)],
    fields: [LEGAL_FORM_FIELD],
  },
  {
    id: "2",
    title: "На якій ви системі оподаткування?",
    titleClassName: "text-lg lg:text-4xl",
    step: DefaultStep,
    responsibleFields: [getFieldName(LEG_ENT_TAXATION_SYSTEM_FIELD)],
    fields: [LEG_ENT_TAXATION_SYSTEM_FIELD],
  },
  {
    id: "3",
    title: "Яка у вас група єдиного податку?",
    titleClassName: "text-lg lg:text-4xl",
    step: DefaultStep,
    responsibleFields: [getFieldName(LEG_ENT_SINGLE_TAX_GROUP_FIELD)],
    fields: [LEG_ENT_SINGLE_TAX_GROUP_FIELD],
  },
  {
    id: "4",
    title: "Чи є ви платником ПДВ?",
    titleClassName: "text-lg lg:text-4xl",
    step: DefaultStep,
    responsibleFields: [getFieldName(LEG_ENT_VAT_PAYER_FIELD)],
    fields: [LEG_ENT_VAT_PAYER_FIELD],
  },
  {
    id: "5",
    title: "Чи є Ви платником акцизного податку?",
    titleClassName: "text-lg lg:text-4xl",
    step: DefaultStep,
    responsibleFields: [getFieldName(LEG_ENT_EXCISE_TAX_PAYER_FIELD)],
    fields: [LEG_ENT_EXCISE_TAX_PAYER_FIELD],
  },
];
// (to)

export const getStepsByForm = (form: LegalForm) => {
  if (form === LegalForm.legEnt) return LEG_ENT_CALCULATOR_STEPS;
  return IND_ENT_CALCULATOR_STEPS;
};
